var dataLayer = (window.dataLayer = window.dataLayer || []);
var useNewArrayLogic = window.location.href.indexOf('tracking-arrays=true') >= 0;
const { calculateEtldPlusOne, domainsWithoutTcfConsent, loadGtmScript } = require('./utils');

module.exports = {
    loadContainer: function (containerId) {
        var gtmAlreadyLoadedClassName = 'gtm-main-container-load-initiated';
        var alreadyInitiatedMainGtmContainerLoaded =
            document.documentElement.className.indexOf(gtmAlreadyLoadedClassName) >= 0;

        if (alreadyInitiatedMainGtmContainerLoaded) {
            // preventing duplicated load of main GTM container
            return;
        }

        document.documentElement.className += ' ' + gtmAlreadyLoadedClassName;

        loadContainer();

        function loadContainer() {
            if (domainsWithoutTcfConsent.includes(calculateEtldPlusOne(location.hostname))) {
                loadGtmScript(containerId);
                return;
            }
            window.__tcfapi('addEventListener', 2, (tcData, success) => {
                if (success && (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete')) {
                    window.__tcfapi('removeEventListener', 2, function () {}, tcData.listenerId);
                    loadGtmScript(containerId);
                }
            });
        }
    },

    push: function () {
        if (!arguments.length) {
            return;
        }

        let args = [].slice.call(arguments);

        args.map(function (data) {
            for (var key in data) {
                if (!useNewArrayLogic || typeof data[key] === 'string') {
                    data[key] = toLower(data[key]);
                }
            }

            return data;
        });

        setTimeout(() => {
            dataLayer.push.apply(dataLayer, args);
        }, 0);
    },
};

function toLower(val) {
    return val && ('' + val).toLowerCase();
}



// WEBPACK FOOTER //
// ./src/gtm/googletagmanager.js